const url =
	process.env.ENVIRONMENT === 'STG'
		? 'https://svnnqvwoce.execute-api.us-east-1.amazonaws.com/dev/nol'
		: process.env.ENVIRONMENT === 'PDN'
		? 'https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/nol'
		: 'https://svnnqvwoce.execute-api.us-east-1.amazonaws.com/dev/nol'

export const CLIENT_ID =
	process.env.ENVIRONMENT !== 'PDN'
		? '10prlbiado4ieqmmv31nedlbc'
		: '4l2ebk4ltfhfu0dnhais1l2qhs'
export const REFRESH_TOKEN =
	process.env.ENVIRONMENT !== 'PDN'
		? 'https://nol-dev.auth.us-east-1.amazoncognito.com/oauth2/token'
		: 'https://nol-pdn.auth.us-east-1.amazoncognito.com/oauth2/token'

export const CONTACT_CASE_URL = url + '/pqrs/api/v1/contact/case'
export const preRegisterUser = url + '/register/api/v1/user'
export const registerUser = url + '/register/api/v1/register'
export const confirmUserCode = url + '/register/api/v1/user/confirmation'
export const resendCode = url + '/register/api/v1/user/resend-code'
export const parentConfirmation =
	url + '/register/api/v1/user/parent-confirmation'
export const infoUser = url + '/register/api/v1/user?email='
export const stateUser = url + '/register/api/v1/status'
export const parentResentConfirmation =
	url + '/register/api/v1/user/resend-parent-request'
export const validateNickName =
	url.replace('/nol', '') +
	'/appnol/register/api/v1/young-user/validate-nickname'

export const authentication = url + '/authentication/api/v1/auth'
export const recoverPass = url + '/recovery/api/v1/recovery'
export const restorePassToken = url + '/recovery/api/v1/change'
export const restorePass = url + '/recovery/api/v1/change-recovery'


export const registerEmail = url + '/register/api/v1/email'
export const registerCellPhone = url + '/register/api/v1/cell-phone'

export const accountInfo = url + '/account/api/v1/user'
export const accountUpdate = url + '/account/api/v1/account'
export const pictureUpdate = url + '/account/api/v1/picture'
export const otpSend = url + '/otp/api/v1/otp'
export const otpValidate = url + '/otp/api/v1/verify-otp'
export const getRequestEmailchange = url + '/account/api/v1/emailChange'
export const createRequestEmailChange = url + '/account/api/v1/emailChange'
export const delateRequestEmailChange = url + '/account/api/v1/emailChange'
export const confirmEmailChange = url + '/account/api/v1/emailChange/confirm'
export const sendOtpEmailChange = url + '/otp/api/v1/otp/email'
export const validateBirthdate = url + '/account/api/v1/validate/birthdate'

export const userNotification =
	url + '/user-notification/api/v1/setup/notification/horoscope'
export const userNotificationSettigns =
	url + '/user-notification/api/v1/notification'
export const notificationSettingsState =
	url + '/user-notification/api/v1/setup/notification'
export const listNotifications = url + '/user-notification/api/v1/notifications'

export const concourseWinners = url + '/competition/api/v1/competition'
export const pointsSaleCities = url + '/competition/api/v1/cities-concourse'
export const pointsSaleOfCity = url + '/competition/api/v1/point-sale-city'
export const getAccumulationsTotal =
	url + '/competition/api/v1/get-accumulation-total/'
export const competitionRedeem =
	url + '/competition/api/v1/competition-participation'

export const summaryProductsResults = url + '/rating/api/v1/review'
export const qualifyProduct = url + '/rating/api/v1/rate-product'
export const commentProduct = url + '/rating/api/v1/review-product'
export const listAverage = url + '/rating/api/v1/products'
export const favoriteProduct = url + '/rating/api/v1/favorites'
export const ratePrizes = url + '/rating/api/v1/rate-prize'
export const reviewPrizes = url + '/rating/api/v1/prize-review'

export const commentsByTopic = url + '/consulting/api/v1/consulting'
export const likesOrDislike = url + '/consulting/api/v1/consultation'
export const consultationReview = url + '/consulting/api/v1/review'

export const sendQuestion = url + '/pqrs/api/v1/claim'

export const postContent = url + '/content/api/v1/file'
export const postContentText = url + '/content/api/v1/text'
export const getCommments = url + '/content/api/v1/commentaries'
export const setCommments = url + '/content/api/v1/comment'
export const setCommmentsReport = url + '/content/api/v1/comment/report'
export const setLikes = url + '/content/api/v1/rate'
export const getLikeById = url + '/content/api/v1/rating'
export const getLikesArticles = url + '/content/api/v1/ratings'

export const postMyKeys = url + '/accumulation/api/v1/key'
export const getPrices = url + '/redemption/api/v1/prizes'
export const getPrice = url + '/redemption/api/v1/prize'
export const getProduct = url + '/accumulation/api/v1/product-key'

export const getAccumulations = url + '/accumulation/api/v1/accumulations'
export const getActivity = url + '/redemption/api/v1/redemptions-activities'
export const getOrders = url + '/redemption/api/v1/redemptions-orders'
export const getSamplesVConfidnet = url + '/v-confident/api/v1/sample-history'
export const downloadPdf = url + '/redemption/api/v1/redemption-detail'

export const pointsAccumulated = url + '/accumulation/api/v1/points'

export const pointsExpired = url + '/account/api/v1/expired-points'

export const promotionalKey = url + '/accumulation/api/v1/promotional-key'

export const getCounsulting = url + '/consulting/api/v1/call-center/consulting'
export const changeSpecialist =
	url + '/consulting/api/v1/call-center/change-specialist'
export const closeQuestion =
	url + '/consulting/api/v1/call-center/close-consultation'
export const getHistory =
	url + '/consulting/api/v1/call-center/consultation-history'
export const sendPQR = url + '/pqrs/api/v1/call-center/claim'
export const getPQRSlist = url + '/pqrs/api/v1/pqrs'
export const getPQRSexcel = url + '/pqrs/api/v1/pqrs/download'
export const updatePQRS = url + '/pqrs/api/v1/pqrs'
export const historyPQRS = url + '/pqrs/api/v1/pqrs/history'
export const historyUser = url + '/history/api/v1/user'
export const commentariesPQRS = url + '/pqrs/api/v1/pqrs/commentaries'
export const commentariesBackoffice = url + '/calls/api/v1/call/commentaries'
export const backoffice = url + '/calls/api/v1/calls'
export const getListArticlesUsers = url + '/content/api/v1/call-center/content'
export const getDetailArticleUser =
	url + '/content/api/v1/call-center/content/detail'
export const updateStateArticle = url + '/content/api/v1/call-center/content'
export const getHistoryUserArticle =
	url + '/content/api/v1/call-center/content/user'
export const getComentaries =
	url + '/content/api/v1/call-center/content/content-commentary'
export const getComentariesProducts =
	url + '/content/api/v1/call-center/content/product-commentary'
export const updateArticleUser =
	url + '/content/api/v1/call-center/content/text'
export const getComplaint =
	url + '/content/api/v1/call-center/content/commentary'
export const getComplaintProduct =
	url + '/content/api/v1/call-center/content/commentary-product'
export const deleteCommentary =
	url + '/content/api/v1/call-center/content/commentary'
export const deleteCommentaryProduct =
	url + '/content/api/v1/call-center/content/commentary-product'
export const deleteComplaint =
	url + '/content/api/v1/call-center/content/complaint-commentary'
export const cancelComplaints =
	url + '/content/api/v1/call-center/content/commentary'

export const saveArticle = url + '/content/api/v1/save'

export const webSocketEndPoint = url + '/user-notification/nol-websocket'

export const redeemPrizes = url + '/redemption/api/v1/redeem'
export const consultingRedeem = url + '/redemption/api/v1/redeem-competitions'
export const getRedeem = url + '/redemption/api/v1/prize-limit'
export const remainingPrizes = url + '/redemption/api/v1/remaining-prizes'

export const GET_IP_ADDRESS = 'https://api.ipify.org?format=json'

export const dataPolicy = url + '/account/api/v1/data-policy'
export const campaignUpdateData =
	url + '/competition/api/v1/competition-participation-information'

export const schoolVisitGrades = url + '/school/api/v1/school-visit-grades'
export const schoolVisitGradesSchedule =
	url + '/school/api/v1/school-visit-jornadas-grados'
export const sendSchoolForm = url + '/school/api/v1/register-school-to-visit'
export const getSchoolInfoByNit = url + '/school/api/v1/schools/info'

export const userProgress = url + '/e-source/progress'

export const calculateMenstrualCycle =
	url + '/calc-menstrual/api/v1/menstrual-cycle/calculate'
export const getMenstrualCycleForecast =
	url + '/calc-menstrual/api/v1/menstrual-cycle/forecast'
